import {ActionType, getActionTypeFromInstance, NgxsNextPluginFn, NgxsPlugin} from "@ngxs/store";
import Logrocket from 'logrocket';
import {Injectable} from "@angular/core";
import {Observable, tap} from "rxjs";


@Injectable()
export class LogRocketPlugin implements NgxsPlugin {
  reduxMiddleware = Logrocket.reduxMiddleware();
  currentState: any = null;
  store = this.reduxMiddleware({
    getState: () => this.currentState,
  });

  constructor() {
  }

  handle(state: any, action: ActionType, next: NgxsNextPluginFn) {
    const type = getActionTypeFromInstance(action);
    let n: Observable<any> = next(state, action)
    return n.pipe(
      tap(nextState => {
        this.currentState = {...state}
        // @ts-ignore
        let a = {type, ...action};
        this.store(() => nextState)(a);
      })
    )
  }
}
